const descendingSuffixes: Array<[string, number]> = [
  ['T', 1e12],
  ['G', 1e9],
  ['M', 1e6],
  ['K', 1e3]
]

export default function shortenNumber(input: number) {
  const integer = parseInt(input.toString(), 10)

  for (const [suffix, threshold] of descendingSuffixes) {
    if (integer >= threshold) {
      return `${(integer / threshold).toFixed(1).replace('.0', '')}${suffix}`
    }
  }

  return integer.toString()
}
